<template>
  <div class="pages">
    <div class="top facab">
      <div class="t-l">{{ $t('main.ReviewPayment') }}</div>
      <div class="t-r fac">
        <div class="t-r-l fac">
          <div style="padding: 0 1.875rem; color: #ccc;">{{ $t('main.AddressInformation') }}</div>
          <img src="/static/product/icn_right_w.png" class="tImg" />
          <div style="padding: 0 1.875rem; color: #ccc;">
            {{ $t('main.ShippingInformation') }}
          </div>
          <img src="/static/product/icn_right_w.png" class="tImg" />
          <div class="t-r-e">{{ $t('main.ReviewPayment') }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="c-th">
        <div>{{ $t('main.OrderInformationHasBeenEntered') }}</div>
      </div>
      <div class="c-detail fac">
        <img src="/static/product/icn_tj.png" class="lImg" />
        <div class="c-r">
          <div class="pb32 fac">
            <div style="width: 120px;">{{ $t('main.OrderNumber') }}：</div>
            {{ orderNum }}
          </div>
          <div v-if="orderType !== '2'" class="pb32 fac">
            <div style="width: 120px;">{{ $t('main.Status') }}：</div>
            <span v-if="orderType==='1'">
            <span v-if="orderStatus==='0'">{{ $t('main.ToBePaid') }}</span>
            <span v-if="orderStatus==='1'">{{ $t('main.ToBeShipped') }}</span>
            <span v-if="orderStatus==='2'">{{ $t('main.ToBeReceived') }}</span>
            <span v-if="orderStatus==='4'">{{ $t('main.Completed') }}</span>
            <span v-if="orderStatus==='8'">{{ $t('main.HasDeleted') }}</span>
            <span v-if="orderStatus==='9'">{{ $t('main.Cancelled') }}</span>
            </span>
          </div>
          <div class="pb32 fac">
            <div style="width: 120px;">{{ $t('main.freight') }}：</div>
            <div class="color-635796">{{ $t('main.monetaryUnit') }} {{ orderFreightPrice }}</div>
          </div>
          <div v-if="orderType !== '2'" class="pb32 fac">
            <div style="width: 120px;">{{ $t('main.totalPrice') }}：</div>
            <div class="color-635796">{{ $t('main.monetaryUnit') }} {{ Math.round( (parseFloat(orderTotalPrice) + parseFloat(orderFreightPrice)) * 100)/100 }}</div>
          </div>
          <a v-if="orderType==1" class="cPointer cBtn" style="padding: 6px 20px;" :href="contractHref" target="_blank">
            {{ $t('main.ViewContract') }}
          </a>
          <a v-if="orderType==1" class="cPointer cBtn" style="margin-left: 1.5rem;padding: 6px 20px;" :href="quotationHref" target="_blank">
            {{ $t('main.ViewQuotation') }}
          </a>
        </div>
      </div>
      <div class="c-bottom">
        <div class="b-l">
          <div style="padding: 1.375rem 0.625rem;">{{ $t('main.ChoosePaymentMethod') }}</div>
          <div class="c-img">
            <img
                v-if="orderType !== '2' && isCN"
                :src="payType===0 ? '/static/product/wx-2@2x.png':'/static/product/wx-1@2x.png'"
                class="pImg" @click="choosePayType(0)"/>
            <img
                v-if="orderType !== '2' && isCN"
                :src="payType===1 ? '/static/product/zf-2@2x.png':'/static/product/zf-1@2x.png'"
                class="pImg" @click="choosePayType(1)"/>
            <img
                v-if="orderType !== '2' && !isCN"
                :src="payType===2 ? '/static/product/pp-2@2x.png':'/static/product/pp-1@2x.png'"
                class="pImg" @click="choosePayType(2)"/>
            <img
                v-if="isCN && (orderTotalPrice > 2000 || payType===3)"
                :src="payType===3 ? '/static/product/hd-2@2x.png':'/static/product/hd-1@2x.png'"
                class="pImg" @click="choosePayType(3)"/>
            <img
                v-if="!isCN"
                :src="payType===3 ? '/static/product/hd-4@2x.png':'/static/product/hd-3@2x.png'"
                class="pImg" @click="choosePayType(3)"/>
          </div>
          <div v-if="payType===2" style="color:#635796;padding: 2rem 0.625rem;">{{ $t('main.paypalNote') }}</div>
        </div>
        <div class="b-r" @click="goToSuccess()">
          {{ $t('main.PayNow') }}
        </div>
      </div>


    </div>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        :before-close="cancelPay"
        :close-on-click-modal="false"
        width="30%"
        center
    >
      <canvas ref="qrcode" v-if="showQrCode"></canvas>

      <el-form v-if="payType===3" ref="form" :model="purchaseData">
        <el-form-item class="is-required" :label="$t('main.purchaseOrderNo')">
          <el-input v-model="purchaseData.purchase_order_no" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.receiver')">
          <el-input v-model="purchaseData.purchase_user" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.ContactPhone')">
          <el-input v-model="purchaseData.purchase_user_phone" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.ContactEmail')">
          <el-input v-model="purchaseData.purchase_user_email" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
      </el-form>

      <span v-if="payType!==3" slot="footer" class="dialog-footer">
         <el-button class="btn-close" @click="cancelPay">{{ $t('main.cancel') }}</el-button>
         <el-button class="btn" @click="surePaySucess">{{ $t('main.paySucess') }}</el-button>
      </span>
      <span v-if="payType===3" slot="footer" class="dialog-footer">
         <el-button class="btn-close" @click="cancelPay">{{ $t('main.cancel') }}</el-button>
         <el-button class="btn" @click="purchasePay">{{ $t('main.commit') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// 支付宝支付参数
import PayPal from 'vue-paypal-checkout'
import { confirmOrder,getHetong, listDetailOrder } from "@/api/order";
import Cookie from 'js-cookie';
import QRCode from 'qrcode'

export default {
  data() {
    return {
      checked: false,
      ischoose: 1,
      createOrderInfo: {},
      paypalaccessToken: "",
      payCurrency:"USD",//还差欧洲币种
      credentials: {
        sandbox: '填写沙箱环境client_id',
        production: 'Ae8qxWGAmXCZabigvKRKOH8Sscj_QIDAHsgYWZQVycLBj4rSeWHiJqWE44sESLxs1_bzitIlnh0Z4Ulj'
      },
      payType: -1,// 0 微信支付  1 支付宝支付  2，paypal支付  3，货到付款
      wechatNewSn: '',
      buttonStyle: {
        label: 'pay',
        size: 'small',
        shape: 'rect',
        color: 'blue'
      },
      orderNum:"",//订单编号
      orderStatus:"",
      orderTotalPrice:"",
      orderFreightPrice:"",
      orderLeaveTime:"",//剩余时间
      orderType: "1", // 订单类型 1：常规订单；2：定制订单
      pay_type:0, //支付方式
      hetongid:"",
      contractHref:"",
      quotationHref:"",
      dialogVisible: false,
      isCN: true, // 判断当前页面中英文，用于展示支付方式
      intervalId: null,//定时任务查询支付状态
      count: 0,//查询支付状态超时秒数
      showQrCode:true,//是否显示二维码
      dialogTitle:"",//弹框提示
      purchaseData: {
        purchase_order_no: "",
        purchase_user: "",
        purchase_user_phone: "",
        purchase_user_email: "",
      }
    };
  },
  watch: {
    "$store.state.siteInfo": function(newV, oldV) {
      this.isCN = this.$i18n.locale === "zn";
      if (newV && typeof oldV != 'object') {
        this.$router.push({ path: "/shoppingCart"});
      }
    }
  },
  components: {
    PayPal
  },
  created() {
    this.init()
  },

  methods: {
    cancelPay(){
      if (this.wechatNewSn) {
        this.$router.push({ path: "/purchase", query:{"sn":this.wechatNewSn}  });
      }
      this.dialogVisible = false;
      clearInterval(this.intervalId);
    },

    surePaySucess(){
      this.searchPayStatus();
      let sn = this.$route.query.sn;
      if (this.wechatNewSn) {
        sn = this.wechatNewSn;
      }
      setTimeout(() => {
        if (this.orderStatus !== '1' && this.orderStatus !== '4' && this.pay_type !== '4') {
          // 没有完成支付的情况
          this.$router.push({ path: "/purchaseError", query:{"sn":sn}  });
        }
      }, 1500);
    },
    init() {
      let params = {
        req: {
          sn: this.$route.query.sn
        }
      }
      listDetailOrder(params).then(res => {
        if(res.rsp.code === 0) {
          this.hetongid = res.data.contract_id;
          this.orderNum = res.data.sn;
          this.orderStatus = res.data.status;
          this.orderFreightPrice = res.data.freight_price;
          this.orderTotalPrice = res.data.total_price;
          this.orderType = res.data.order_type;
          this.pay_type = res.data.pay_type;
          this.quotationHref = res.data.quotation_href;
          this.getContractHref(); //查询收获地址显示
          this.isCN = this.$i18n.locale === "zn";
          if (this.orderStatus === '1' || this.orderStatus === '4' || this.pay_type === '4') {
            this.$router.push({ path: "/purchaseSuccess", query:{"sn":this.$route.query.sn}  });
          }
        }
      })

    },

    getContractHref(){
        var params =  {
        "req": {
            "id": this.hetongid
        }
        }
      getHetong(params).then((res) => {
        this.contractHref = res.data.contract_url;
      });
    },
    //选择支付方式
    choosePayType(type){
      this.payType = type;
    },
    goToSuccess() {
      // （点击去支付之前需要获取最新的订单详情）
      if (this.payType === -1) {
        this.$message({
          message: this.$t('main.ChoosePaymentMethod'),
          type: 'error'
        })
        return
      }
      //调用微信 支付宝 paypal 支付
      if(this.payType === 0){
        // 微信支付
          this.showQrCode = true;
          this.dialogTitle = this.$t('main.pleaseScan')
          this.payWx();
      }

      if(this.payType === 1){
        // 支付宝支付
        this.payZfb();
        this.showQrCode = false;
        this.dialogTitle = this.$t('main.pleaseSurePayStatus')
      }

      if(this.payType === 2){
        // paypal支付
        this.payPalpal();
        this.showQrCode = false;
        this.dialogTitle = this.$t('main.pleaseSurePayStatus')
      }

      if(this.payType === 3){
        // 货到付款
        this.cashondelivery();
        this.showQrCode = false;
        this.dialogTitle = this.$t('main.PurchaseOrderNote')
      }
    },

    //跳转后台返回来的地址
    goToExternalWebsite(url) {
      window.open(url, '_blank');
    },
    //查询支付状态
    searchPayStatus() {
      let sn = this.$route.query.sn;
      if (this.wechatNewSn) {
        sn = this.wechatNewSn;
      }
      let params = {
        req: {
          sn: sn
        }
      }
      listDetailOrder(params).then(res => {
        if(res.rsp.code === 0) {
          this.hetongid = res.data.contract_id;
          this.orderNum = res.data.sn;
          this.orderStatus = res.data.status;
          this.orderFreightPrice = res.data.freight_price;
          this.orderTotalPrice = res.data.total_price;
          this.orderType = res.data.order_type;
          this.pay_type = res.data.pay_type;
          this.quotationHref = res.data.quotation_href;

          // TODO 如果是成功跳转  关闭轮询
          if (this.orderStatus === '1' || this.orderStatus === '4' || this.pay_type === '4') {
            this.$router.push({ path: "/purchaseSuccess", query:{"sn":this.$route.query.sn}  });
          }
        }
      })
    },

    //微信支付
    payWx(){
      // 微信扫码支付
      const wxPayParams = {
        "req": {
          "sn": this.$route.query.sn,
          "info": {
            "pay_type": 2,
            "wechat_type":"native"
          }
        }
      };
      // 确认订单 confirmOrder
      confirmOrder(wxPayParams).then((res) => {
        if (res.rsp.code === 0) {
          this.dialogVisible = true;
          const codeUrl = res.data.pay_data.pay_body.code_url;
          const that = this;
          this.wechatNewSn = res.data.sn;

          setTimeout(() => {
            QRCode.toCanvas(this.$refs.qrcode, codeUrl, function () {
              // 开始轮询支付结果
              // that.intervalId = setInterval(that.searchPayStatus, 3000);
            })
          }, 1000);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },

    //支付宝支付
    payZfb(){
      const aliPayParams = {
        "req": {
          "sn": this.$route.query.sn,
          "info": {
            "pay_type": 3
          }
        }
      };

      // 确认订单 confirmOrder
        confirmOrder(aliPayParams).then((res) => {
          if (res.rsp.code === 0) {
            this.dialogVisible = true;
            const aliUrlBody = res.data.pay_data.pay_body.pc.body;
            const that = this;
            that.intervalId = setInterval(that.searchPayStatus, 3000);

            // 新窗口打开支付页面
            const newWin = window.open('');
            newWin.document.write(aliUrlBody)
            // 关闭输出流
            newWin.document.close()
          } else {
            this.$message({
              message: res.rsp.msg,
              type: "error",
            });
          }
      });
    },

    // paypal支付
    payPalpal(){
      const payPalPayParams = {
        "req": {
          "sn": this.$route.query.sn,
          "info": {
            "pay_type": 1
          }
        }
      };

      // 确认订单 confirmOrder
        confirmOrder(payPalPayParams).then((res) => {
          if (res.rsp.code === 0) {
            this.dialogVisible = true;
            const payPalPayUrl = res.data.pay_data.pay_body.approval_url;
            const that = this;
            that.intervalId = setInterval(that.searchPayStatus, 3000);
            this.goToExternalWebsite(payPalPayUrl);  //替换为后台返回来的url
          } else {
            this.$message({
              message: res.rsp.msg,
              type: "error",
            });
          }
      });
    },

    //货到付款
    cashondelivery(){
      if (!this.isCN) {
        this.dialogVisible = true;
      } else {
        this.purchasePay();
      }
    },
    purchasePay() {
      const purchaseParams = {
        "req": {
          "sn": this.$route.query.sn,
          "info": {
            "pay_type": 4,
            "purchase_order_no": this.purchaseData.purchase_order_no,
            "purchase_user": this.purchaseData.purchase_user,
            "purchase_user_phone": this.purchaseData.purchase_user_phone,
            "purchase_user_email": this.purchaseData.purchase_user_email,
          }
        }
      };

      if (!this.isCN && !this.purchaseData.purchase_order_no) {
        this.$message({
          message: this.$t('main.fieldIsRequired', { field: this.$t('main.purchaseOrderNo') }),
          type: 'error'
        })
        return
      }

      // 确认订单 confirmOrder
      confirmOrder(purchaseParams).then((res) => {
        if (res.rsp.code === 0) {
          this.surePaySucess()
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      })
    }
  },

   beforeDestroy() {
    // 在组件销毁前清除定时任务
    clearInterval(this.intervalId);
  },

  mounted() {
  }
};
</script>

<style scoped lang="less">

::v-deep .el-dialog__body{
  text-align: center;
  padding: 0;
}
.pages {
  min-height: 100%;
  background-color: #fff;

  .top {
    .t-l {
      font-size: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #635796;
      line-height: 2.25rem;
    }

    .t-r {
      border-bottom: 2px solid #635796;
      height: 2.125rem;
      line-height: 2rem;

      .t-r-l {
        background: #635796;
        border-radius: 2px;
      }

      .t-r-e {
        padding: 0 1.25rem;
        color: #fff;
        font-weight: bold;
      }

      .tImg {
        width: 1.5rem;
        height: 0.75rem;
        margin: 0 0.75rem;
      }
    }
  }

  .content {
    min-width: 75rem;

    .c-th {
      height: 3.75rem;
      line-height: 3.75rem;
      background: #f2f2f2;
      border: 1px solid #e6e6e6;
      padding: 0 0.625rem;
    }

    .c-detail {
      padding: 3rem 0 3rem 10%;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;

      .lImg {
        width: 512px;
      }

      .c-r {
        padding-left: 10%;
      }

      .cBtn {
        width: 15.625rem;
        height: 2.5rem;
        line-height: 2.5rem;
        border: 1px solid #635796;
        border-radius: 4px;
        text-align: center;
        color: #635796;
        margin-top: 4rem;
      }
    }

    .c-bottom {
      height: 14.625rem;
      background: #f2f2f2;
      border: 1px solid #e6e6e6;
      display: flex;

      .b-l {
        width: calc(100% - 10rem);
      }

      .b-r {
        width: 10rem;
        height: 100%;
        line-height: 14.625rem;
        background: #635796;
        font-size: 1.285rem;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
      }

      .c-img {
        display: flex;
        padding-top: 1.5rem;

        .pImg {
          height: 62px;
          cursor: pointer;
          margin: 0 2.5rem;
        }

        .pText {
          color: #999999;
          padding: 1rem 2.5rem;
        }
      }
    }
  }

  /deep/ .el-dialog__header {
    background: #f2f2f2;
    padding: 1rem 1rem 1rem 1.5rem;
    border-radius: 2px;
  }
  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  /deep/ .el-dialog__title {
    color: #000000;
  }

  /deep/ .el-dialog__body {
    padding: 0.5rem 3rem;
  }
  .btn {
    background: #635796;
    border-radius: 4px;
    border-color: #635796;
    color: #ffffff;
  }
  .btn-close {
    background: #FFF;
    border-radius: 4px;
    border-color: #DCDFE6;
    color: #606266;
  }
  @media screen and (max-width: 1400px) {
    .top {
      padding: 3.25rem 2%;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .top {
      padding: 3.25rem 10%;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .top {
      padding: 3.25rem 15%;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }

  .pb32 {
    padding-bottom: 2rem;
  }
}
</style>
